import { useLayoutEffect, useState } from 'react'

const WIDE_SCREEN_WIDTH = 1440

export const useWindowSizeIsWide = () => {
  const [isWide, setIsWide] = useState(window.innerWidth >= WIDE_SCREEN_WIDTH)
  useLayoutEffect(() => {
    const updateSize = () => {
      const newIsWide = window.innerWidth >= WIDE_SCREEN_WIDTH
      setIsWide(newIsWide)
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])
  return isWide
}
